<template>
  <v-widget
    :title="$t('Role Permissions')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-btn
        flat
        class="text--secondary text-capitalize"
        @click="addPermissionsDialog=true"
      >
        {{ $t('Add Permissions') }}
      </v-btn>
    </div>

    <div slot="widget-content">
      <v-flex>
        <v-text-field
          v-model="search"
          :label="$t('Search')"
          append-icon="search"
          single-line
          hide-details
        />
      </v-flex>

      <v-data-table
        :items="role.permissions"
        :headers="headers"
        :search="search"
        :rows-per-page-text="$t('Rows per page')"
        item-key="name"
      >
        <template v-slot:items="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ `${item.app}:${item.store}:${item.action}:${item.resourceProp}` }}</td>
            <td class="text-xs-right">
              <v-icon
                color="red"
                small
                @click="deletePermission(item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:pageText="props">
          <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
        </template>
      </v-data-table>

      <AddRelationDialog
        :dialog="addPermissionsDialog"
        :headers="permissionsDialogHeaders"
        :fields="permissionsDialogFields"
        :selected="role.permissions"
        :title="$t('Add Permissions')"
        model="auth:permission"
        @relation-items-added="addPermissions"
        @dialog-closed="addPermissionsDialog=false"
      />
    </div>
  </v-widget>
</template>

<script>
import AddRelationDialog from '@/vuetify-console/components/AddRelationDialog'

export default {
  name: 'RolePermissions',

  components: {
    AddRelationDialog
  },

  props: {
    role: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false,
      search: '',
      addPermissionsDialog: false,
      permissionsDialogFields: [
        { name: 'name', format: 'string' },
        { name: 'app', format: 'string' },
        { name: 'store', format: 'string' },
        { name: 'action', format: 'string' },
        { name: 'resourceProp', format: 'string' }
      ]
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Scope'), sortable: false }
      ]
    },

    permissionsDialogHeaders () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('App'), sortable: false },
        { text: this.$t('Store'), sortable: false },
        { text: this.$t('Action'), sortable: false },
        { text: this.$t('Resource'), sortable: false }
      ]
    }
  },

  methods: {
    deletePermission (permission) {
      this.role.permissions = this.role.permissions.filter(e => e.id !== permission.id)
    },

    addPermissions (permissions) {
      this.role.permissions = this.role.permissions ? this.role.permissions.concat(permissions) : permissions
      this.addPermissionsDialog = false
    }
  }
}
</script>
